import { Helpers } from "./helpers/helpers";

export class VideoPlayer {
	private wrapper: HTMLElement;
	private video: HTMLVideoElement;
	private playButton: HTMLElement;
	private autoplay: boolean;

	

	constructor() {

		document.querySelectorAll(".video-player").forEach((element: HTMLElement)=> {
			this.initPlayButton(element);
		});

		document.querySelectorAll(".video-embed").forEach((element: HTMLElement) => {
			this.initVideoEmbed(element);
		});

		
	}


	private initPlayButton(wrapper: HTMLElement): void {
		const onClickCallback = () => {
			const video = wrapper.querySelector("video");
			video.play();
			wrapper.querySelector(".play-button").classList.add("d-none");
			wrapper.removeEventListener("click", onClickCallback);
		};

		wrapper.addEventListener("click", onClickCallback);
	}

	private initVideoEmbed(widgetWrapper: HTMLElement): void {
		const videoOverlay = widgetWrapper.querySelector('.video-overlay') as HTMLElement;
		if (videoOverlay) {
			const youTubeEmbed = widgetWrapper.querySelector('.youtube-embed') as HTMLElement;
			if (youTubeEmbed) {
				const youTubeVideoSrc = Helpers.getYoutubeEmbedCode(youTubeEmbed.getAttribute('src'));

				videoOverlay.addEventListener('click',
					function handler() {
						videoOverlay.removeEventListener('click', handler);
						youTubeEmbed.setAttribute('src',
							"//www.youtube.com/embed/" +
							youTubeVideoSrc +
							"?rel=0&showinfo=0&iv_load_policy=3&enablejsapi=1&autoplay=1");
						videoOverlay.classList.add('d-none');
					});
			}
		}
	}

}